import type {OrganizationName, FilenameSchemaEntry} from "#material-outputs-filenames/types"
import * as maharam from "#material-outputs-filenames/schemas/maharam"
import * as designtex from "#material-outputs-filenames/schemas/designtex"
import * as keilhauer from "#material-outputs-filenames/schemas/keilhauer"
import * as teknion from "#material-outputs-filenames/schemas/teknion"
import * as luumTextiles from "#material-outputs-filenames/schemas/luum-textiles"
import * as kvadrat from "#material-outputs-filenames/schemas/kvadrat"
import * as ldiInteriors from "#material-outputs-filenames/schemas/ldi-interiors"
import * as infected from "#material-outputs-filenames/schemas/infected"
import * as ultrafabrics from "#material-outputs-filenames/schemas/ultrafabrics"
import * as glenRaven from "#material-outputs-filenames/schemas/glen-raven"
import * as kravet from "#material-outputs-filenames/schemas/kravet"
import * as leeJofa from "#material-outputs-filenames/schemas/lee-jofa"
import * as donghia from "#material-outputs-filenames/schemas/donghia"
import * as brunschwigFils from "#material-outputs-filenames/schemas/brunschwig-fils"
import * as gabriel from "#material-outputs-filenames/schemas/gabriel"
import * as hugoBoss from "#material-outputs-filenames/schemas/hugo-boss"
import * as camira from "#material-outputs-filenames/schemas/camira"

const allSchemas = [
    maharam,
    designtex,
    keilhauer,
    teknion,
    luumTextiles,
    kvadrat,
    ldiInteriors,
    infected,
    ultrafabrics,
    glenRaven,
    kravet,
    leeJofa,
    donghia,
    brunschwigFils,
    gabriel,
    hugoBoss,
    camira,
]

export const ASSETS_FILENAME_SCHEMAS_FOR_ORGANIZATION: Record<OrganizationName, FilenameSchemaEntry[]> = Object.fromEntries(
    allSchemas.map((m) => [m.organizationName, m.schemas]),
) as Record<OrganizationName, FilenameSchemaEntry[]>
